<template>
    <div class="rmf__container">
        <div class="bg-white">
            <div class="rmf__text">
                <p v-text="$t('RATE_MY_FLOWERS_TO_HEAR')"></p>
                <p v-text="$t('RATE_MY_FLOWERS_PLEASE_LET')"></p>
                <subscription-dropdown v-if="hasMultipleActiveSubscriptions" class="rmf__dropdown"/>
            </div>
        </div>
        <div class="background--paper divider--container">
            <div class="divider-white--top"></div>
            <transition name="transitionFade">
                <rate-arrangement
                    v-if="activeSubscription"
                    :key="activeSubscription.id">
                </rate-arrangement>
            </transition>
            <div class="divider-paper--bottom"></div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import RateArrangement from '@/components/partials/account/rate-my-flowers/RateArrangement';
import SubscriptionDropdown from '@/components/partials/account/rate-my-flowers/SubscriptionDropdown';

export default {
    name: 'RateMyFlowers',
    created() {
        this.$store.dispatch('subscription/fetchAllSubscriptions');
        this.$store.dispatch('address/fetchAllAddresses');
        this.$store.dispatch('cms/fetchRateableArrangements');
    },
    computed: {
        ...mapGetters({
            hasMultipleActiveSubscriptions: 'subscription/hasMultipleActiveSubscriptions',
            activeSubscription: 'subscription/getActiveSubscription',
        }),
    },
    components: {
        SubscriptionDropdown,
        RateArrangement,
    },
};
</script>

<style lang="scss" scoped>
.rmf{
    &__container {
        padding-top: 50px;
        overflow-x: hidden;
    }
    &__text {
        margin: 0 auto;
        text-align: center;
        padding: 0 16px 16px;
        max-width: 500px;
    }
    &__dropdown {
        padding: 8px 0;
    }
}
</style>
